// Reusable "click → track → open partner URL" helper. Used by Home cards,
// ProductCard on marketplace, and product detail page.  Keeps the flow
// identical everywhere so cashback attribution never breaks.
import { api } from "./api";
import { withUtm, getSessionId, getStoredUTM, getUserId, setUserId } from "./utm";
import { getInviteSlug, getInviteTag } from "./invite";

export async function doTrackedRedirect(product) {
  try {
    const inviteSlug = getInviteSlug();
    const inviteTag = getInviteTag();
    const { data } = await api.post("/track/click", {
      product_id: product.id,
      session_id: getSessionId(),
      user_id: getUserId() || undefined,
      ...getStoredUTM(),
      referrer: document.referrer || "",
      current_url: window.location.href,
      ...(inviteSlug ? { invite_slug: inviteSlug } : {}),
      ...(inviteSlug && inviteTag ? { invite_tag: inviteTag } : {}),
    });
    if (data?.user_id) setUserId(data.user_id);
    const url = data?.tracked_redirect_url || withUtm(product.redirect_url);
    if (url) window.open(url, "_blank", "noopener,noreferrer");
  } catch {
    if (product.redirect_url) {
      window.open(withUtm(product.redirect_url), "_blank", "noopener,noreferrer");
    }
  }
}

// Has the visitor already given their mobile number this session?
// A HITCH-USER-* id in localStorage is our proof of prior identification.
export function hasIdentity() {
  const uid = getUserId();
  return uid && uid.startsWith("HITCH-USER-");
}
